import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { GetUserKYCsResponse } from './types/Kyc';

export default (makeCall: MakeCall) =>
  (
    userId: 'me' | number = 'me',
    query?: {
      limit?: number;
      offset?: number;
    },
  ) =>
    makeCall<GetUserKYCsResponse>('GET', `/api/v2/user/${userId}/kyc`, {
      query,
    });
